import {
    GET_SHIPPING_OPTIONS_SUCCESS,
    GET_SHIPPING_OPTIONS_FAIL,
    GET_SHIPPING_LIST_SUCCESS,
    GET_SHIPPING_LIST_FAIL,
    GET_SHIPPING_SUCCESS,
    GET_SHIPPING_FAIL
} from '../actions/types';

const initialState = {
    shipping: null,
};
const initialStateShippingFull = {
    shippings: null,
    shipping: null,
    count : null,
    next : null,
    previous : null
};
export default function Shipping(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case GET_SHIPPING_OPTIONS_SUCCESS:
            return {
                ...state,
                shipping: payload.shipping_options
            }
        case GET_SHIPPING_OPTIONS_FAIL:
            return {
                ...state,
                shipping: null
            }
        default:
            return state;
    }
};

export function ShippingFull(state = initialStateShippingFull, action) {
    const { type, payload } = action;

    switch(type) {
        case GET_SHIPPING_LIST_SUCCESS:
            return {
                ...state,
                shippings: payload.results,
                count: payload.count,
                next: payload.next,
                previous: payload.previous
            }
        case GET_SHIPPING_LIST_FAIL:
            return {
                ...state,
                shippings: null,
                count: null,
                next: null,
                previous: null
            }
        case GET_SHIPPING_SUCCESS:
            return {
                ...state,
                shipping: payload
            }
        case GET_SHIPPING_FAIL:
            return {
                ...state,
                shipping: null
            }
        default:
            return state;
    }
}
